export default String.raw`
{% if settings.blockAddingEmployees == 'no' -%}
	{% assign canAddEmployees = true -%}
{% elseif settings.blockAddingEmployeesFor == 'withLimits' and customer.CreditLimit == null -%}
	{% assign canAddEmployees = true -%}
{% else -%}
	{% assign canAddEmployees = false -%}
{% endif -%}

<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{translations.Employees}}
		{% assign currentCompanyName = customer.CompanyId -%}
		{% if canAddEmployees -%}
		<div class="btn-drop-content-js add-employee-button-js">
			<button class="secondary-action-button set-focus-trap-js replace-template-js" data-template="partials/customer-profile/employees-list/add-employee.html" data-container=".add-employee-form-container-js">
				{{ translations.AddEmployee }}</span>
			</button>
			<div class='add-employee-form-container-js container-js'></div>
		</div>
		{% endif -%}
	</div>
	{% if canAddEmployees == false -%}
		<div class="message-container">{{ translations.AddEmployeeInfo }}</div>
	{% endif -%}
	<div class="employees-list-view-js parent-container-js">
		{% include 'partials/customer-profile/employees-list/employees-view-lis.html' -%}
	</div>  
</div>
`